import { Tooltip as AlchemyTooltip } from '@m/alchemy-ui/Tooltip';
import { FormattedMessage, useIntl } from 'react-intl';
import * as Styled from './IdeaCard.styled';

export const NextPhaseBadge = () => {
  const intl = useIntl();

  return (
    <AlchemyTooltip
      trigger={
        <Styled.NextPhaseLabel role="region">
          <FormattedMessage id="inNextPhase" defaultMessage="In next phase" />
        </Styled.NextPhaseLabel>
      }
      placement="top"
      contents={intl.formatMessage({
        id: 'inNextPhaseTooltip',
        defaultMessage:
          'This means that this idea will appear in the next phase, either through being chosen by the admins, or automatically via the settings for the current phase.'
      })}
    />
  );
};
